/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseHoraireIncoherenceGridDto } from './FcbClasseHoraireIncoherenceGridDto';
import {
    FcbClasseHoraireIncoherenceGridDtoFromJSON,
    FcbClasseHoraireIncoherenceGridDtoFromJSONTyped,
    FcbClasseHoraireIncoherenceGridDtoToJSON,
} from './FcbClasseHoraireIncoherenceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseHoraireIncoherenceGridDtoPaginatedResults
 */
export interface FcbClasseHoraireIncoherenceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseHoraireIncoherenceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseHoraireIncoherenceGridDto>}
     * @memberof FcbClasseHoraireIncoherenceGridDtoPaginatedResults
     */
    results?: Array<FcbClasseHoraireIncoherenceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseHoraireIncoherenceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseHoraireIncoherenceGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseHoraireIncoherenceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseHoraireIncoherenceGridDtoPaginatedResultsFromJSON(json: any): FcbClasseHoraireIncoherenceGridDtoPaginatedResults {
    return FcbClasseHoraireIncoherenceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseHoraireIncoherenceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseHoraireIncoherenceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseHoraireIncoherenceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseHoraireIncoherenceGridDtoPaginatedResultsToJSON(value?: FcbClasseHoraireIncoherenceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseHoraireIncoherenceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

